import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getCurrencies = ({ pageNumber = 1 }) => {
  return axios.get(`/currency/all/${pageNumber}`);
};

export const useCurrencies = ({ pageNumber = 1, config }) => {
  return useQuery({
    ...config,
    queryKey: ['currencies', pageNumber],
    queryFn: () => getCurrencies({ pageNumber }),
  });
};
